/* eslint-disable max-lines */
import { useContext, useEffect } from 'react';
import { Box, Grid, Typography, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { SubmissionPageStyles as classes } from './SubmissionPageStyles';
import ErrorImage from '../../images/error-icon.png';
import { clearContext } from '../clearContext';
import { clearDoChecklistContext } from '../CommercialDeposit/DragDropFiles/DocLabelTypes';
import { getAccessToken } from '../../services/tokenService';
import { isWebComponentFlow } from '../commonCode';
import { handleBacktoAccount } from '../../WebComponents/commonComponents/customUtils';

const SubmissionFailPage = (props) => {
  const { t } = useTranslation();
  const baseContext = isWebComponentFlow();

  const { history, resetErrorBoundary, isErrorBoundary } = props;
  const { isQR, wcFlow, initiateUiResponse } = baseContext;

  useEffect(() => {
    baseContext.pauseTimerAndClearInterval();
    baseContext.clearPingTimer();
  }, []);

  useEffect(() => {
    let unListen = null;
    unListen = history.listen(() => {
      if (history.action === 'POP') {
        if (
          initiateUiResponse.REACT_APP_ENVIRONMENT === 'development' ||
          baseContext.environment === 'dev'
        ) {
          clearDoChecklistContext(baseContext);
          clearContext(baseContext);

          history.push('/');
        } else {
          let url = '';
          if (baseContext.location === 'PR') {
            url = `https://orientalbank.com/${baseContext.language?.toLowerCase()}`;
          } else if (baseContext.location === 'VI') {
            url = `https://orientalbank.com/${baseContext.language?.toLowerCase()}/${baseContext.location?.toLowerCase()}`;
          } else {
            url = `https://orientalbank.com/`;
          }
          window.location.href = url;
        }
      }
    });
    return unListen;
  }, []);

  const handleRoute = async () => {
    if (
      initiateUiResponse.REACT_APP_ENVIRONMENT === 'development' ||
      baseContext.environment === 'dev'
    ) {
      clearDoChecklistContext(baseContext);
      clearContext(baseContext);

      const token = await getAccessToken({ env: '' });
      if (token) {
        baseContext.startTimer();
        baseContext.pingTimer(token);
        baseContext.setAccessToken(token);
        history.push('/');
      }
    } else {
      let url = '';
      if (isQR) {
        url = `https://orientalbank2016.sharepoint.com/sites/OrientalIntranet/SitePages/External-web-links.aspx`;
      } else if (baseContext.location === 'PR') {
        url = `https://orientalbank.com/${baseContext.language?.toLowerCase()}`;
      } else if (baseContext.location === 'VI') {
        url = `https://orientalbank.com/${baseContext.language?.toLowerCase()}/${baseContext.location?.toLowerCase()}`;
      } else {
        url = `https://orientalbank.com/`;
      }
      window.location.href = url;
    }
  };

  const handleRestart = async () => {
    clearContext(baseContext);
    const token = await getAccessToken({ env: '' });
    if (token) {
      baseContext.pingTimer(token);
      baseContext.setAccessToken(token);
      baseContext.startTimer();
      history.push(
        `/?ao_productType=${baseContext.productType}&ao_productName=${baseContext.productName}&ao_location=${baseContext.location}&ao_language=${baseContext.language}&utm_campaign=${baseContext.utmCampaign}&utm_source=${baseContext.utmSource}&utm_medium=${baseContext.utmMedium}&utm_content=${baseContext.utmContent}&utm_term=${baseContext.utmTerm}`
      );
      resetErrorBoundary();
    }
  };

  return (
    <div
      role="main"
      aria-describedby="screenSubmitHeading screenSubmitHeadingDesc screenSubmitHeadingDescFail"
    >
      <Grid container>
        <Grid
          size={{ xs: 12 }}
          style={{ display: 'flex', justifyContent: 'center' }}
          sx={classes.imgGrid}
        >
          <Box component="img" src={ErrorImage} sx={classes.error} alt="Submission Failed" />
        </Grid>
        <Grid size={{ xs: 12 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Typography variant="h2" id="screenSubmitHeadingDescFail" sx={classes.errorTitle}>
            {t('Sorry we hit a snag. Please try submitting your application later.', {
              defaultValue: 'Sorry we hit a snag. Please try submitting your application later.',
            })}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }} style={{ display: 'flex', justifyContent: 'center' }}>
          {wcFlow ? (
            <Button
              disableFocusRipple
              autoFocus
              sx={classes.returnToOrientalInError}
              data-testid="BackToMyAccounts"
              title="BackToMyAccounts"
              onClick={handleBacktoAccount}
            >
              {t('Go to my accounts', { defaultValue: 'Go to my accounts' })}
            </Button>
          ) : isErrorBoundary ? (
            <Button
              disableFocusRipple
              autoFocus
              sx={classes.returnToOrientalInError}
              data-testid="ReturnToOrientalButtonTitle"
              title="ReturnToOrientalButtonTitle"
              onClick={handleRestart}
            >
              {t('Restart my application', { defaultValue: 'Restart my application' })}
            </Button>
          ) : (
            <Button
              disableFocusRipple
              autoFocus
              sx={classes.returnToOrientalInError}
              data-testid="ReturnToOrientalButtonTitle"
              title="ReturnToOrientalButtonTitle"
              onClick={handleRoute}
            >
              {t('Return to orientalbank.com', { defaultValue: 'Return to orientalbank.com' })}
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

SubmissionFailPage.propTypes = {
  isErrorBoundary: PropTypes.bool,
  resetErrorBoundary: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    listen: PropTypes.func,
    action: PropTypes.string,
  }),
};

export default withRouter(SubmissionFailPage);
